import React from 'react';
export const contact = {
  info: <>
    Let&apos;s collaborate <br />
    Always looking for new opportunities <br/>
    Browse my gitHub repositories, or check out my linkedIn page. <br/>
    Send me an email or fill out the contact form below!</>
};